export default __webpack_public_path__ + "static/media/PowellCatLocation-04.e8c0cced.jpg";